import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import AbroadCellularPackageBlockData from 'Models/Content/AbroadCellularPackageBlockData';
import AbroadCellularPackagesItemsBlockData from 'Models/Content/AbroadCellularPackagesItemsBlockData';
import React, {useState} from 'react';
import {Container} from 'reactstrap';
import AbroadCellularPackageBlock from '../AbroadCellularPackageBlock';
import {PopupContext} from '../../../utilities/PopupContext';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';

import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';

export type PopupData = {
  summary: string;
  title: string;
};

const AbroadCellularPackagesItemsBlock = (props: ComponentProps<AbroadCellularPackagesItemsBlockData>) => {
  const [popUpData, setPopUpData] = useState<PopupData>();
  const {data, context} = props;
  return (
    <PopupContext.Provider
      value={{
        setPopUpData,
      }}>
      <BlockWrapper props={props}>
        <div className='AbroadCellularPackagesItemsBlock'>
          {/* Mobile */}
          <Swiper
            spaceBetween={-16}
            centeredSlides
            slidesPerView={1.1}
            pagination={{clickable: true}}
            className='AbroadCellularPackagesItemsBlock__swiper d-block d-md-none'>
            {data.cellularItems.expandedValue.map((pkg: AbroadCellularPackageBlockData, i) => (
              <SwiperSlide key={i}>
                <AbroadCellularPackageBlock data={pkg} context={context} />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* 768 to 992px */}
          <Swiper slidesPerGroup={2} slidesPerView={2} className='AbroadCellularPackagesItemsBlock__swiper	d-none d-md-block d-lg-none'>
            {data.cellularItems.expandedValue?.map((pkg: AbroadCellularPackageBlockData, i) => (
              <SwiperSlide key={i}>
                <AbroadCellularPackageBlock data={pkg} context={context} />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Desktop */}
          <Container className='AbroadCellularPackagesItemsBlock__items d-none d-lg-block'>
            <div className='AbroadCellularPackagesItemsBlock__items__wraper'>
              <ContentArea data={data.cellularItems} context={context} noWrap />
            </div>
          </Container>
        </div>
      </BlockWrapper>

      <PopUp className={'AbroadCellularPackagesItemsBlock__container-popup'} showPopUp={popUpData} onClose={() => setPopUpData(null)}>
        <div className='InternalTvContentsItemsBlock__container-popup__popup-title-and-text'>
          <h4>{popUpData?.title}</h4>

          <div dangerouslySetInnerHTML={{__html: popUpData?.summary}}></div>
        </div>
      </PopUp>
    </PopupContext.Provider>
  );
};

export default AbroadCellularPackagesItemsBlock;
